export const CATEGORIES_MOCK = {
  success: true,
  data: {
    root: {
      id: 1,
      name: 'Наручные часы',
      slug: 'naruchnye-chasy',
      url: '/catalog/2-2/',
    },
    items: [
      {
        category: {
          id: 1,
          name: 'Наручные часы',
          slug: 'naruchnye-chasy',
          url: '/catalog/2-2/',
        },
        link_groups: [
          {
            name: 'подборки',
            items: [
              {
                id: 501,
                name: 'Новинки',
                slug: 'novinki',
                url: '/catalog/2-2/',
              },
              {
                id: 502,
                name: 'Бестселлеры',
                slug: 'bestsellery',
                url: '/catalog/2-2/',
              },
              {
                id: 503,
                name: 'Скидки',
                slug: 'skidki',
                url: '/catalog/2-2/',
              },
              {
                id: 504,
                name: 'Подарки для него',
                slug: 'podarki-dlya-nego',
                url: '/catalog/2-2/',
              },
              {
                id: 505,
                name: 'Подарки для нее',
                slug: 'podarki-dlya-nee',
                url: '/catalog/2-2/',
              },
              {
                id: 506,
                name: 'Смотреть всё',
                slug: 'smotret-vse',
                url: '/catalog/2-2/',
              },
            ],
          },
          {
            name: 'статус',
            items: [
              {
                id: 601,
                name: 'Эксклюзив',
                slug: 'eksklyuziv',
                url: '/catalog/2-2/',
              },
              {
                id: 602,
                name: 'Лимитированная коллекция',
                slug: 'limitirovannaya-kollektsiya',
                url: '/catalog/2-2/',
              },
              {
                id: 603,
                name: 'Премиальные часы',
                slug: 'premium-chasy',
                url: '/catalog/2-2/',
              },
              {
                id: 604,
                name: 'Недорогие часы',
                slug: 'nedorogie-chasy',
                url: '/catalog/2-2/',
              },
              {
                id: 605,
                name: 'Спортивные часы',
                slug: 'sportivnye-chasy',
                url: '/catalog/2-2/',
              },
            ],
          },
          {
            name: 'механизм',
            items: [
              {
                id: 701,
                name: 'Механические часы',
                slug: 'mekhanicheskie-chasy',
                url: '/catalog/2-2/',
              },
              {
                id: 702,
                name: 'Кварцевые часы',
                slug: 'kvartsevye-chasy',
                url: '/catalog/2-2/',
              },
            ],
          },
          {
            name: 'дополнительно',
            items: [
              {
                id: 801,
                name: 'Часы-скелетоны',
                slug: 'chasy-skeletony',
                url: '/catalog/2-2/',
              },
              {
                id: 802,
                name: 'Часы-хронограф',
                slug: 'chasy-khronograf',
                url: '/catalog/2-2/',
              },
              {
                id: 803,
                name: 'Парные часы',
                slug: 'parnye-chasy',
                url: '/catalog/2-2/',
              },
            ],
          },
        ],
        children: [
          {
            category: {
              id: 2,
              name: 'Мужские часы',
              slug: 'muzhskie-chasy',
              url: '/catalog/2-2/',
            },
          },
          {
            category: {
              id: 3,
              name: 'Женские часы',
              slug: 'muzhskie-chasy',
              url: '/catalog/2-2/',
            },
          },
          {
            category: {
              id: 4,
              name: 'Коллекции и&nbsp;линейки',
              slug: 'muzhskie-chasy',
              url: '/catalog/2-2/',
            },
            link_groups: [
              {
                name: 'Линейки',
                items: [
                  {
                    id: 701,
                    name: 'Art',
                    slug: 'art',
                    url: '/catalog/2-2/',
                  },
                  {
                    id: 702,
                    name: 'Bijoy',
                    slug: 'bijoy',
                    url: '/catalog/2-2/',
                  },
                  {
                    id: 703,
                    name: 'Classic',
                    slug: 'classic',
                    url: '/catalog/2-2/',
                  },
                  {
                    id: 704,
                    name: 'Cosmos',
                    slug: 'cosmos',
                    url: '/catalog/2-2/',
                  },
                  {
                    id: 705,
                    name: 'Elegance',
                    slug: 'elegance',
                    url: '/catalog/2-2/',
                  },
                  {
                    id: 706,
                    name: 'Flora',
                    slug: 'flora',
                    url: '/catalog/2-2/',
                  },
                  {
                    id: 707,
                    name: 'Spectr',
                    slug: 'spectr',
                    url: '/catalog/2-2/',
                  },
                  {
                    id: 708,
                    name: 'UNI',
                    slug: 'uni',
                    url: '/catalog/2-2/',
                  },
                  {
                    id: 709,
                    name: 'Vintage',
                    slug: 'vintage',
                    url: '/catalog/2-2/',
                  },
                ],
              },
            ],
            plates_groups: [
              {
                name: 'коллекции',
                items: [
                  {
                    id: 601,
                    name: '12 месяцев',
                    slug: '12-mesyacev',
                    url: '/catalog/2-2/',
                    image: '/temp/collections/tmp.jpg',
                    count: 11,
                  },
                  {
                    id: 602,
                    name: 'Mix',
                    slug: 'mix',
                    url: '/catalog/2-2/',
                    image: '/temp/collections/tmp.jpg',
                    count: 5,
                  },
                  {
                    id: 603,
                    name: 'Луна 24',
                    slug: 'luna-24',
                    url: '/catalog/2-2/',
                    image: '/temp/collections/tmp.jpg',
                    count: 6,
                  },
                  {
                    id: 604,
                    name: 'Метеорит',
                    slug: 'meteorite',
                    url: '/catalog/2-2/',
                    image: '/temp/collections/tmp.jpg',
                    count: 4,
                  },
                  {
                    id: 605,
                    name: 'Секрет Эмили',
                    slug: 'secret-emily',
                    url: '/catalog/2-2/',
                    image: '/temp/collections/tmp.jpg',
                    count: 1,
                  },
                  {
                    id: 606,
                    name: 'Соло',
                    slug: 'solo',
                    url: '/catalog/2-2/',
                    image: '/temp/collections/tmp.jpg',
                    count: 11,
                  },
                  {
                    id: 607,
                    name: 'Спутник',
                    slug: 'sputnik',
                    url: '/catalog/2-2/',
                    image: '/temp/collections/tmp.jpg',
                    count: 3,
                  },
                  {
                    id: 608,
                    name: 'Эмили',
                    slug: 'emily',
                    url: '/catalog/2-2/',
                    image: '/temp/collections/tmp.jpg',
                    count: 5,
                  },
                  {
                    id: 609,
                    name: 'Высоцкий',
                    slug: 'vysotsky',
                    url: '/catalog/2-2/',
                    image: '/temp/collections/tmp.jpg',
                    count: 7,
                  },
                  {
                    id: 610,
                    name: 'Медуза',
                    slug: 'meduza',
                    url: '/catalog/2-2/',
                    image: '/temp/collections/tmp.jpg',
                    count: 18,
                  },
                  {
                    id: 611,
                    name: 'Астра',
                    slug: 'astra',
                    url: '/catalog/2-2/',
                    image: '/temp/collections/tmp.jpg',
                    count: 8,
                  },
                  {
                    id: 612,
                    name: 'Комета',
                    slug: 'cometa',
                    url: '/catalog/2-2/',
                    image: '/temp/collections/tmp.jpg',
                    count: 9,
                  },
                  {
                    id: 613,
                    name: 'Омега',
                    slug: 'omega',
                    url: '/catalog/2-2/',
                    image: '/temp/collections/tmp.jpg',
                    count: 16,
                  },
                  {
                    id: 614,
                    name: 'Небо',
                    slug: 'nebo',
                    url: '/catalog/2-2/',
                    image: '/temp/collections/tmp.jpg',
                    count: 17,
                  },
                ],
              },
            ],
          },
          {
            category: {
              id: 5,
              name: 'Конфигуратор часов',
              slug: 'muzhskie-chasy',
              url: '/catalog/2-2/',
            },
          },
        ],
      },
      {
        category: {
          id: 6,
          name: 'Часы-перстни и&nbsp;кулоны',
          slug: 'chasy-perstni-kulony',
          url: '/catalog/2-2/',
        },
      },
      {
        category: {
          id: 7,
          name: 'Ремешки',
          slug: 'remeshki',
          url: '/catalog/2-2/',
        },
      },
      {
        category: {
          id: 8,
          name: 'Сертификаты',
          slug: 'sertifikaty',
          url: '/catalog/2-2/',
        },
      },
    ],
  },
};
